/*
 * @Author: Ryan
 * @Date: 2026-01-13
 * @Description: TikTok Hero Supporting Section - 三个工具图片展示
 */
import Image from 'next/image';
import React from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';

import styles from './index.module.scss';

// 工具图片数据
const TOOLS_DATA = [
  {
    id: 'image-to-video',
    imageUrl:
      'https://assets.falcocut.ai/tools/tiktok-video-generator/image-to-video.webp',
  },
  {
    id: 'text-to-video',
    imageUrl:
      'https://assets.falcocut.ai/tools/tiktok-video-generator/text-to-video.webp',
  },
  {
    id: 'ai-avatars',
    imageUrl: 'https://assets.falcocut.ai/tools/tiktok-video-generator/ai-avatars.webp',
  },
];

export interface ToolItem {
  title: string;
  description: string;
  imageUrl?: string;
}

export interface TikTokHeroSupportingSectionProps {
  /** 标题 */
  title: string;
  /** 副标题 */
  subtitle: string;
  /** 工具列表 */
  tools: ToolItem[];
  /** CTA 按钮文本 */
  ctaText?: string;
  /** 跳转链接 */
  ctaUrl?: string;
}

const TikTokHeroSupportingSection: React.FC<TikTokHeroSupportingSectionProps> = ({
  title,
  subtitle,
  tools,
  ctaText = 'Create TikTok Videos',
  ctaUrl = '/ai-video-generator',
}) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题区域 */}
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        {/* 工具卡片区域 */}
        <div className={styles.toolsWrapper}>
          {tools.map((tool, index) => {
            const toolData = {
              id: TOOLS_DATA[index]?.id || `tool-${index}`,
              imageUrl: tool.imageUrl || TOOLS_DATA[index]?.imageUrl || '',
            };
            return (
              <div key={toolData.id} className={styles.toolCard}>
                {/* 图片区域 */}
                <div className={styles.imageWrapper}>
                  {toolData.imageUrl ? (
                    <Image
                      src={toolData.imageUrl}
                      alt={tool.title}
                      width={340}
                      height={340}
                      className={styles.image}
                    />
                  ) : (
                    <div className={styles.imagePlaceholder} />
                  )}
                </div>

                {/* 文字区域 */}
                <div className={styles.toolContent}>
                  <h3 className={styles.toolTitle}>{tool.title}</h3>
                  <p className={styles.toolDescription}>{tool.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA 按钮 */}
        <div className={styles.ctaWrapper}>
          <StartButton text={ctaText} href={ctaUrl} className={styles.ctaButton} />
        </div>
      </div>
    </section>
  );
};

export default TikTokHeroSupportingSection;
